var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstruccion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.804 3-12 20.785 9.526 5.5-.732-2.732 2.732-.732-1.598-3.233 2.732-.732-1.598-3.232 2.732-.732-1.598-3.232 2.732-.732-.732-2.732 2.732-.732.268-4.464z",
    fill: "#d0d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.866 18.624.307-.082a4.99 4.99 0 0 1 -.869-6.088l4.469-7.74-2.973-1.714-12 20.785 9.526 5.5-.726-2.732 2.732-.733-1.6-3.232 2.732-.732z",
    fill: "#93999a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8 61a1 1 0 0 1 -.867-.5l-1-1.732a1 1 0 0 1 .367-1.368l8.661-5a1 1 0 0 1 1 1.733l-7.794 4.5.5.866a1 1 0 0 1 -.867 1.501z",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fcbc04",
    height: 12,
    rx: 2,
    transform: "matrix(-.5 -.866 .866 -.5 -17.97 84.696)",
    width: 12,
    x: 9.464,
    y: 41.536
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.069 41.413a6 6 0 0 1 -2.605 7.319l-1.678.968 2.482 4.3a2 2 0 0 0 2.732.732l6.929-4a2 2 0 0 0 .732-2.732l-4-6.929a2 2 0 0 0 -2.732-.732z",
    fill: "#e59730"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.464,
    cy: 47.536,
    fill: "#f89c8d",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.037 48.009a1.989 1.989 0 0 1 -1.446.212 2.052 2.052 0 0 0 .141.315 2 2 0 1 0 2.178-2.944 2 2 0 0 1 -.873 2.417z",
    fill: "#f8664f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.66 31.464h20v8h-20z",
    fill: "#84d2f4",
    transform: "matrix(.866 .5 -.5 .866 19.562 -2.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.648 30.838a4.987 4.987 0 0 1 -6.658 1.59l-2.343-1.353-1.647 2.853 17.32 10 4-6.928z",
    fill: "#57b7eb"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9e109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.33 29.5-2 3.464a1 1 0 1 1 -1.732-1l2-3.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.794 31.5-2 3.464a1 1 0 1 1 -1.732-1l2-3.464z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fcbc04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.23 33.09a.957.957 0 0 1 -.77.37 1.009 1.009 0 0 1 -.5-.13 1 1 0 0 1 -.48-.66 4.536 4.536 0 0 0 1.75.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.79 31.5-2 3.46a.97.97 0 0 1 -.86.5.983.983 0 0 1 -.5-.13 1.01 1.01 0 0 1 -.37-1.37l.89-1.53a4.958 4.958 0 0 0 1.7-1.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.581 6.042h11v10h-11z",
    fill: "#d0d8da",
    transform: "matrix(.707 -.707 .707 .707 -3.098 14.606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.95 14.174h4v10h-4z",
    fill: "#d0d8da",
    transform: "matrix(.707 -.707 .707 .707 -11.23 11.237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.778 13.346h4v6h-4z",
    fill: "#656b76",
    transform: "matrix(.707 -.707 .707 .707 -8.401 12.409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.042 4.325-.065.018a6.934 6.934 0 0 0 -4.867 4.867l-.018.065-4.243-4.243a6.937 6.937 0 0 1 8.008-1.3z",
    fill: "#d0d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.042 11.295h6v20h-6z",
    fill: "#57b7eb",
    transform: "matrix(.707 -.707 .707 .707 -7.138 25.359)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#93999a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.556 11.639a4 4 0 0 1 -5.657 0l-2.242-2.239-2 2 7.071 7.071 7.778-7.778-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.95 20-3.95-3.947-1 1 7.071 7.071 2.829-2.824-1.03-1.034a2.991 2.991 0 0 1 -3.92-.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.877 3.336a6.949 6.949 0 0 0 -1.832 1.854 1.778 1.778 0 0 1 -2.751.287l-1.329-1.329a6.892 6.892 0 0 0 -1.116.884l4.243 4.243.017-.065a6.937 6.937 0 0 1 4.868-4.867l.065-.018-1.185-.592a6.959 6.959 0 0 0 -.98-.397z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.234 15.245-1.268 1.268a1.379 1.379 0 0 1 -1.949 0 1.38 1.38 0 0 1 0-1.95l1.267-1.263-1.192-1.2-4.243 4.243 14.142 14.145 4.243-4.243z",
    fill: "#4891d3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.652 29-1.447-1.447 15.556-15.557 4.243 4.243-11.181 11.18z",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.675 13.082-4.914 4.918a7.845 7.845 0 0 0 .586.657 7.962 7.962 0 0 0 4.934 2.309l4.719-4.727-1.5-1.5-1.086 1.086z",
    fill: "#656b76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.367 8.876-5.949 5.949-4.243-4.243 5.949-5.949a8 8 0 1 0 4.243 4.243z",
    fill: "#d0d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.66 13.653a7.994 7.994 0 0 1 -13.65-5.53 7.993 7.993 0 1 0 14.97 3.763 7.922 7.922 0 0 1 -1.32 1.767z",
    fill: "#93999a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m59 44v-10h-4.719a17.9 17.9 0 0 0 -1.52-3.69l3.331-3.331-7.071-7.071-3.331 3.331a17.918 17.918 0 0 0 -3.69-1.52v-4.719h-10v4.719a17.918 17.918 0 0 0 -3.69 1.52l-3.331-3.331-7.071 7.071 3.331 3.331a17.9 17.9 0 0 0 -1.52 3.69h-4.719v10h4.719a17.918 17.918 0 0 0 1.52 3.69l-3.331 3.331 7.071 7.071 3.331-3.331a17.918 17.918 0 0 0 3.69 1.52v4.719h10v-4.719a17.918 17.918 0 0 0 3.69-1.52l3.331 3.331 7.071-7.071-3.331-3.331a17.918 17.918 0 0 0 1.52-3.69zm-22 4a9 9 0 1 1 9-9 9 9 0 0 1 -9 9z",
    fill: "#f9e109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 54a26 26 0 0 1 -25.01-33.1l-6.082 6.082 3.331 3.331a17.9 17.9 0 0 0 -1.52 3.687h-4.719v10h4.719a17.918 17.918 0 0 0 1.52 3.69l-3.331 3.331 7.071 7.071 3.331-3.331a17.918 17.918 0 0 0 3.69 1.52v4.719h10v-4.719a17.918 17.918 0 0 0 3.69-1.52l3.331 3.331 4.49-4.49a26.1 26.1 0 0 1 -4.511.398z",
    fill: "#fcbc04"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruccion);
export default __webpack_public_path__ + "static/media/construccion.134850c4d8ce471b095845de862dddb3.svg";
export { ForwardRef as ReactComponent };